/** @typedef {import('@basqet-dashboard/common/types/models').PaymentLink} PaymentLink */
/** @typedef {import('@basqet-dashboard/common/types/api').ApiResponse} ApiResponse */

import { instance } from '@basqet-dashboard/common/config/api';

/** @returns {Promise<ApiResponse<PaymentLink[]>>} */
const fetchPaymentLinks = async () => {
  const { data } = await instance.get(`paymentlinks`);
  return data;
};

/**
 * @param {Partial<PaymentLink>} body
 * @returns {Promise<ApiResponse<PaymentLink>>}
 */
const createPaymentLink = async (body) => {
  const { data } = await instance.post('paymentlinks/create-payment-link', body);
  return data;
};

/**
 * @param {string} slug_url
 * @returns {Promise<ApiResponse<object>>}
 */
const deletePaymentLink = async (slug_url) => {
  const { data } = await instance.delete(`paymentlinks/${slug_url}`);
  return data;
};

export { createPaymentLink, deletePaymentLink, fetchPaymentLinks };
